export default __webpack_public_path__ + "static/media/reports.cb690c7c.svg";